import { ModalProps } from './types'

import * as S from './styles'
import { useState } from 'react'

const Modal = ({ ...props }: ModalProps) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <S.CardLeaf onClick={() => setShowModal(true)}>
        <S.Figure>
          <img
            src={props.image}
            title={props.metaImgTitle}
            alt={props.metaImgAlt}
          />
        </S.Figure>
        <S.Content>
          {props.time && <S.Time>{props.time}</S.Time>}
          <h3 title={props.metaTitle}>{props.title}</h3>
        </S.Content>
      </S.CardLeaf>

      {showModal && (
        <S.Modal onClick={() => setShowModal(false)}>
          <S.ImageContainer>
            <img
              src={props.image}
              title={props.metaImgTitle}
              alt={props.metaImgAlt}
              width={550}
              height={550}
            />
          </S.ImageContainer>
        </S.Modal>
      )}
    </>
  )
}
export default Modal
